import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './translations'

Vue.use(VueI18n)

const allowed = ['es', 'la', 'en', 'cat']
const raw =
  typeof localStorage !== 'undefined' ? localStorage.getItem('language') : null
const initial = allowed.indexOf(raw) !== -1 ? raw : 'es'

export const i18n = new VueI18n({
  locale: initial,
  messages
})



// WEBPACK FOOTER //
// ./src/i18n.js